/**
 * Simple Place Search component
 * @emits openDirectionsMode
 * @emits switchToDirections
 */

import PlaceInput from "@/fragments/forms/place-input/PlaceInput.vue";
import AppMode from "@/support/app-modes/app-mode";
import MapViewData from "@/models/map-view-data";
import { PlacesSearch } from "@/support/ors-api-runner";
import constants from "@/resources/constants";
import Place from "@/models/place";
import placemarker from "../../../assets/img/place_black_36.svg";
import dotmarker from "../../../assets/img/circle.svg";
import clock from "../../../assets/img/clock.svg";
import keyboard from "../../../assets/img/keyboard_double.svg";
import mylocation from "../../../assets/img/my_location.svg";
import GeoUtils from "../../../support/geo-utils";
import GPS_fixed from "../../../assets/img/my_location.svg";
import GiraLogo from "../../../assets/img/giraLogo.png";
export default {
  data: () => ({
    GiraLogo,
    GPS_fixed,
    mylocation,
    keyboard,
    placemarker,
    dotmarker,
    clock,
    rawResponse: null,
    place: new Place(),
    searching: false,
    extraProfilesOpen: false,
    myLocation: false,
    autoFocusOnMap: true,
    openingRouteMode: false,
    newInfoAvailable: false,
    showDirectionsBtnTooltip: false,
    menu: true,
    focused: false,
    focusedsecond: false,
    firstText: "",
    secondText: "",
    secondField: false,
    submitbutton: false,
    giraStationRoute: false,
    giratogglebutton: false,
    routeSwapFieldOne: null,
    routeSwapFieldSecond: null,
    routedrowdirection :false,
    routeCheck:false,
    showSecondTextFeild : false,
    swapButtonToggle:true,
    show:false,
    hostportData:false,
    inserthostportlink:true,
    placeSuggestionsone: [],
    keyCodeListener: 0
  }),
  props: {
    height: {
      default: 65
    }
  },
  created() {
    this.setEventListeners();
    this.setPlace();
    this.loadData();
    this.setShowDirectionsBtnTooltip();
    if (!this.$lowResolution) {
      document.body.classList.add("modal-open");
    }
  },
  components: {
    PlaceInput
  },
  watch: {
    "$store.getters.isSidebarVisible": function() {
      this.setShowDirectionsBtnTooltip();
    },
  },
  computed: {
    showSuggestion() {
      let show = this.focused;
      return show;
    },
    showSuggestion1() {
      let show = this.focusedsecond;
      return show;
    },
    visible() {
      let isVisible = this.$lowResolution;
      if (this.$store.getters.isSidebarVisible) {
        isVisible = false;
      }
      return isVisible;
    },
    showNewInfo() {
      return this.newInfoAvailable;
    },
    showRouteDetailsTooltip() {
      return this.showNewInfo && !this.$store.getters.isSidebarVisible;
    },
    // search history show
    // placeSuggestionsone() {
    //   // if (!this.focused) {
    //   //   return []
    //   // }
    //   let suggestions = [];
    //   // if (this.localModel.nameIsCoord()) {
    //   // const lnglatArr = this.localModel.getLngLatArr()
    //   // const rawCoordinatesPlace = new Place(lnglatArr[0], lnglatArr[1], this.localModel.placeName, { properties: { layer: 'rawCoordinate' } })
    //   // rawCoordinatesPlace.rawCoordinate = true
    //   // suggestions.push(rawCoordinatesPlace)
    //   // }
    //   // localStorage.setItem('history_search', JSON.stringify([]));
    //   let get_coockie = localStorage.getItem("history_search");
    //   if (get_coockie !== "") {
    //     var convert_arrays = JSON.parse(get_coockie);
    //     if (convert_arrays.length !== 0) {
    //       convert_arrays &&
    //         convert_arrays.map(data => {
    //           suggestions.push(data);
    //         });
    //     }
    //   }
    //   // suggestions = suggestions.concat(this.localModel.suggestions)
    //   // console.log(suggestions)
    //   return suggestions;
    // },
    // search history show
    placeSuggestionssecond() {
      // if (!this.focused) {
      //   return []
      // }
      let suggestions = [];
      // if (this.localModel.nameIsCoord()) {
      // const lnglatArr = this.localModel.getLngLatArr()
      // const rawCoordinatesPlace = new Place(lnglatArr[0], lnglatArr[1], this.localModel.placeName, { properties: { layer: 'rawCoordinate' } })
      // rawCoordinatesPlace.rawCoordinate = true
      // suggestions.push(rawCoordinatesPlace)
      // }
      // localStorage.setItem('history_search', JSON.stringify([]));
      let get_coockie = localStorage.getItem("history_search");
      if (get_coockie !== "") {
        var convert_arrays = JSON.parse(get_coockie);
        if (convert_arrays.length !== 0) {
          convert_arrays &&
            convert_arrays.map(data => {
              suggestions.push(data);
            });
        }
      }
      // suggestions = suggestions.concat(this.localModel.suggestions)
      // console.log(suggestions)
      return suggestions;
    }
  },

  methods: {
    setShowDirectionsBtnTooltip() {
      setTimeout(() => {
        this.showDirectionsBtnTooltip = !this.$store.getters.isSidebarVisible;
      }, 1000);
    },
    /**
     * Se the place model if the app is in place mode
     * and it there is only one place in appRouteData
     */
    setPlace() {
      const showPlaceNameModes = [
        constants.modes.place,
        constants.modes.roundTrip,
        constants.modes.search,
        constants.modes.isochrones
      ];
      if (
        showPlaceNameModes.includes(this.$store.getters.mode) &&
        this.$store.getters.appRouteData.places.length === 1
      ) {
        this.place = this.$store.getters.appRouteData.places[0];
      }
    },
    /**
     * Every time the appRouteData changes
     * and it has at least one place defined
     * the map data is reloaded, so we keep the
     * the map search and synchronized with the url
     */
    reloadAfterAppRouteDataChanged(appRouteData) {
      if (appRouteData && appRouteData.places.length > 0) {
        this.loadData();
      }
    },
    // when call enter text from feild
    inputFocusedone(event) {
      // this.secondField = true
      if(this.routeSwapFieldSecond !== null) {
        this.eventBus.$emit('centerMapFouseTextfield', this.routeSwapFieldSecond)
      }
      this.eventBus.$emit('hostportModalCloseOpenDropdwon',true)
      if (this.firstText !== null && this.firstText.length !== 0) {
        this.focused = false;
      } else {
        let cookies = localStorage.getItem("history_search");
        cookies = JSON.parse(cookies);
        cookies = cookies.length;
        if (cookies !== 0) {
          this.focused = true;
        }
      }
      this.focusedsecond = false;
      setTimeout(() => {
        this.setSwitchHeight();
      }, 30);
    },
    // when call enter text To feild
    inputFocusedsecond(event) {
      this.eventBus.$emit('hostportModalCloseOpenDropdwon',true)
      if(this.routeSwapFieldOne !== null) {
        this.eventBus.$emit('centerMapFouseTextfield', this.routeSwapFieldOne)
      }
      if (this.secondText !== null && this.secondText.length !== 0) {
        this.focusedsecond = false;
      } else {
        this.focusedsecond = true;
      }
      this.focused = false;
      setTimeout(() => {
        this.setSwitchHeight();
      }, 30);
    },
    changed(event = null) {
      if (event) {
        this.focused = false;
        const isPasteEvent = event instanceof ClipboardEvent;
      }
      if (this.firstText.length !== 0) {
      } else {
        this.focused = true;
      }
    },
    // selectd place set
    selectSuggestion(placeSuggestions) {
      let places = new Place(
        placeSuggestions.lng,
        placeSuggestions.lat,
        placeSuggestions.placeName,
        {
          properties: {
            layer: placeSuggestions.properties.layer,
            country: placeSuggestions.properties.country
          }
        }
      );
      this.routeSwapFieldSecond = places;
      this.eventBus.$emit("GoogleAPI", places, 1);
      this.eventBus.$emit("RoutePlaceSecond", places);
      this.eventBus.$emit("girastationsecond", {
        lat: places.lat,
        lng: places.lng
      });
      this.firstText = places.placeName;
      this.focused = false;
      this.secondField = true;
      this.showSecondTextFeild=true;
      if(this.routeCheck) {
        this.routedrowdirection = true
      }
      
      setTimeout(() => {
        this.setSwitchHeight();
      }, 30);
    },
    // selectd place set
    selectSuggestionsecond(placeSuggestions) {
      let places = new Place(
        placeSuggestions.lng,
        placeSuggestions.lat,
        placeSuggestions.placeName,
        {
          properties: {
            layer: placeSuggestions.properties.layer,
            country: placeSuggestions.properties.country
          }
        }
      );
      this.routeSwapFieldOne = places;
      this.eventBus.$emit("GoogleAPI", places, 0);
      this.eventBus.$emit("RoutePlaceOne", places);
      this.eventBus.$emit("girastationone", {
        lat: places.lat,
        lng: places.lng
      });
      this.secondText = places.placeName;
      this.focusedsecond = false;
      this.submitbutton = true;
      this.routedrowdirection = true
      setTimeout(() => {
        this.setSwitchHeight();
      }, 30);
    },
    // remove marker To place
    placeClearedone(index) {
      this.eventBus.$emit("removemarkerfirst");
      this.routeSwapFieldSecond = null
    },
    // remove marker from place
    placeClearedtwo(index) {
      this.eventBus.$emit("removemarkersecond");
      this.routeSwapFieldOne = null
      // console.log(index);
      // this.eventBus.$emit("removePalceone", index);
    },
    // call on blur text feild
    checkplaceinputvalueDesktop() {
      setTimeout(() => {
        this.focused = false;
        if(this.firstText === null || this.firstText.length === 0) {
          this.secondField = false
        }
        this.eventBus.$emit('hostportModalCloseOpenDropdwon',false)
      }, 300);
      setTimeout(() => {
        this.setSwitchHeight();
      }, 300);
    },
     // call on blur text feild
    checkplace2inputvalueDesktop() {
      setTimeout(() => {
        this.focusedsecond = false;
        this.eventBus.$emit('hostportModalCloseOpenDropdwon',false)
      }, 300);
      setTimeout(() => {
        this.setSwitchHeight();
      }, 300);
    },
    // route draw 
    routedrow() {
      this.$gtag.event("calculate-route-click", {
        event_category: "route",
        event_label: "Calculate safest route clicked",
        value: "routeClikedCounts"
      });
      
      if (
        this.firstText !== null &&
        this.secondText !== null &&
        this.firstText.length !== 0 &&
        this.secondText.length !== 0
      ) {
        this.eventBus.$emit("toggleRoundTripmobile");
        this.routedrowdirection = false
      }
      setTimeout(() => {
        this.setSwitchHeight();
      }, 50);
    },
    // hostpot hide show on map
    hostportdata(event) {
      if (event === true) {
        this.hostportData = true
        this.eventBus.$emit("hosportStatus", true);
        this.eventBus.$emit("HostportStatus", true);
        if (document.getElementsByClassName("hosport-marker").length > 0) {
          let hostport = document.getElementsByClassName("hosport-marker")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("hosport-marker")
              [index].setAttribute(
                "style",
                "visibility:visible !important;cursor:pointer;"
              );
          }
        }
        let heightGet = document.getElementsByClassName("dropdown-list-right")[0]
        .offsetHeight;
        document
          .getElementsByClassName("simple-place-search-desktop")[1]
          .setAttribute("style", "top:" + (heightGet + 140) + "px;");

        this.eventBus.$emit('addHostport');
        if (document.getElementsByClassName("circle-change").length > 0) {
          let hostport = document.getElementsByClassName("circle-change")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("circle-change")
              [index].setAttribute(
                "style",
                "display:block;"
              );
          }
        }
        this.$gtag.event("show_dangerous_hotspot_points", {
          event_category: "dangerous_hotspot",
          event_label: "User Enables to Show Dangerous & Hotspots area",
          value: "on"
        });
      } else {
        this.hostportData = false
        this.eventBus.$emit("hosportStatus", false);
        this.eventBus.$emit("HostportStatus", false);

        if (
          document.getElementsByClassName("leaflet-popup-close-button").length >
          0
        ) {
          document
            .getElementsByClassName("leaflet-popup-close-button")[0]
            .click();
        }
        let heightGet = document.getElementsByClassName("dropdown-list-right")[0]
        .offsetHeight;
        document
          .getElementsByClassName("simple-place-search-desktop")[1]
          .setAttribute("style", "top:" + (heightGet + 92) + "px;");
        if (document.getElementsByClassName("hosport-marker").length > 0) {
          let hostport = document.getElementsByClassName("hosport-marker")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("hosport-marker")
              [index].setAttribute("style", "visibility:hidden !important;pointer-events:none !important;");
             

          }
        }
        this.eventBus.$emit('removeHostport');
        if (document.getElementsByClassName("circle-change").length > 0) {
          let hostport = document.getElementsByClassName("circle-change")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("circle-change")
              [index].setAttribute(
                "style",
                "display:none;"
              );
          }
        }

        this.$gtag.event("hide_dangerous_hotspot_points", {
          event_category: "dangerous_hotspot",
          event_label: "User Disables to Show Dangerous & Hotspots area",
          value: "off"
        });
      }
    },
    // Gira hide show on map
    giradata(event) {
      if (event === true) {
        this.eventBus.$emit("giraRouteDraw");
        this.giratogglebutton = true;
        this.eventBus.$emit("checkGiraStationStatus", true);
        this.$gtag.event("gira_stations_on", {
          event_category: "gira_stations",
          event_label: "User Enables to calculate the route with Gira Stations",
          value: "on"
        });
        // if (document.getElementsByClassName("gira-marker").length > 0) {
        //   let hostport = document.getElementsByClassName("gira-marker").length;
        //   for (let index = 0; index < hostport; index++) {
        //     document
        //       .getElementsByClassName("gira-marker")
        //       [index].setAttribute(
        //         "style",
        //         "display:block !important;cursor:initial;"
        //       );
        //   }
        // }
        this.eventBus.$emit('addGira');
      } else {
        this.eventBus.$emit("simpleRouteDraw");
        this.giratogglebutton = false;
        this.eventBus.$emit("checkGiraStationStatus", false);
        // if (document.getElementsByClassName("gira-marker").length > 0) {
        //   let hostport = document.getElementsByClassName("gira-marker").length;
        //   for (let index = 0; index < hostport; index++) {
        //     document
        //       .getElementsByClassName("gira-marker")
        //       [index].setAttribute("style", "display:none !important");
        //   }
        // }
        this.eventBus.$emit('removeGira');
        this.$gtag.event("gira_stations_off", {
          event_category: "gira_stations",
          event_label: "User Disables to calculate the route with Gira Stations",
          value: "off"
        });
      }
    },
    //gira route hide show
    dotlinecss(event) {
      if (event === true) {
        if (
          document.getElementsByClassName("gira_station_route").length > 0 &&
          this.giraStationRoute
        ) {
          let gira = document.getElementsByClassName("gira_station_route")
            .length;
          for (let index = 0; index < gira; index++) {
            document
              .getElementsByClassName("gira_station_route")
              [index].setAttribute("style", "display:block;");
          }
        }
      } else {
        if (document.getElementsByClassName("gira_station_route").length > 0) {
          let gira = document.getElementsByClassName("gira_station_route")
            .length;
          for (let index = 0; index < gira; index++) {
            document
              .getElementsByClassName("gira_station_route")
              [index].setAttribute("style", "display:none;");
          }
        }
      }
    },
    // selct current location
    setLocationFromBrowser() {
      GeoUtils.getBrowserLocation()
        .then(location => {
          // context.$store.commit('currentLocation', location)
          // context.myLocationActive = showLocation

          // Set returned location as map center
          // const latlng = GeoUtils.buildLatLong(location.lat, location.lng)
          const placeName = "Your location";
          const place = new Place(location.lng, location.lat, placeName, {
            properties: { layer: "venue" }
          });
          this.routeSwapFieldOne = place;
          this.eventBus.$emit("GoogleAPI", place, 0);
          this.eventBus.$emit("RoutePlaceOne", place);
          this.secondText = place.placeName;
          this.routedrowdirection = true

          this.focused = false;
          this.focusedsecond = false;
          this.submitbutton = true;
          // this.setMapCenter(latlng)
        })
        .catch(error => {
          // const message = this.getPositionErrorMessage(error)
          // context.showWarning(message, { timeout: 0 })
          // context.myLocationActive = false
          // console.log(error)
        });
    },
    /**
     * Set event listeners
     */
    setEventListeners() {
      const context = this;
      // Set marker clicked event listener
      // When in search place mode, if the marker is clicked, we select it as the target
      // for the inputIndex
      this.eventBus.$on('tooltopClose', () => {
        this.show = false;
      })
      this.eventBus.$on('removeInsertHostportLinkClickable', () => {
        this.inserthostportlink = true
      });
      this.eventBus.$on('addInsertHostportLinkClickable', () => {
        this.inserthostportlink = false
      });
      this.eventBus.$on('tooptipShow',() => {
        this.tooptipShow();
      })
      this.eventBus.$on('routeCheck',(value) => {
        this.routeCheck = value;
      })
      this.eventBus.$on("markerClicked", marker => {
        const lat = marker.data.geometry.coordinates[1];
        const lng = marker.data.geometry.coordinates[0];
        const placeOptions = { resolve: false, id: marker.data.properties.id };
        const place = new Place(lng, lat, marker.label, placeOptions);
        this.selectPlace(place);
      });
      this.eventBus.$on("giraStationRoute", () => {
        this.giraStationRoute = true;
        if (this.giratogglebutton) {
          this.dotlinecss(true);
        } else {
          this.dotlinecss(false);
        }
      });
      this.eventBus.$on("giradataCssChange", () => {
        this.giradata(true);
      });
      // When a marker drag finishes, update
      // the place coordinates and re render the map
      this.eventBus.$on("markerDragged", marker => {
        context.place.coordinates = [marker.position.lng, marker.position.lat];
        context.loadData();
      });
      this.eventBus.$on("menuToggle", value => {
        this.menu = value;
      });

      // reload the map data after the app route has changed
      this.eventBus.$on("appRouteDataChanged", appRouteData => {
        context.reloadAfterAppRouteDataChanged(appRouteData);
      });

      // When there are changes in the route and and the
      // side bar is not opened, notify visually that there
      // new data about the route calculated that can be seen
      // by opening the sidebar
      this.eventBus.$on("newInfoAvailable", available => {
        if (!context.$store.getters.isSidebarVisible) {
          context.newInfoAvailable = available;
        }
      });

      this.eventBus.$on("searched", () => {
        if (!context.$store.getters.isSidebarVisible) {
          context.newInfoAvailable = true;
        }
        context.$emit("searched");
      });

      this.eventBus.$on("refreshSearch", () => {
        context.refreshSearch();
      });

      // When the user click on a marker to remove it
      // and there is only one place
      this.eventBus.$on("removePlace", () => {
        if (context.$store.getters.mode === constants.modes.place) {
          context.place = new Place();
        }
      });
    },

    refreshSearch() {
      const appMode = new AppMode(this.$store.getters.mode);
      const newRoute = appMode.getRoute([this.place]);

      // Only navigate to a new route if params has changed
      const zoomChanged =
        Number(newRoute.params.zoom) !== Number(this.$route.params.zoom);
      const centerChanged =
        newRoute.params.center !== this.$route.params.center;
      const termChanged = newRoute.params.term !== this.$route.params.term;
      if (zoomChanged || termChanged || centerChanged) {
        this.$router.push(newRoute);
      }
    },

    /**
     * Load the map data from the url
     * rebuilding the place inputs and it values
     * and render the map with these data (place or route)
     */
    loadData() {
      const places = this.$store.getters.appRouteData.places.slice(0);

      if (places.length === 1) {
        this.place = places[0];
      }
      if (this.$store.getters.mode === constants.modes.search) {
        if (!this.place.nameIsCoord()) {
          let mapSettings = this.$store.getters.mapSettings;
          mapSettings.mapCenter = this.$store.getters.appRouteData.options.center;
          this.$store.dispatch("saveSettings", mapSettings).then(() => {
            this.search();
            this.$forceUpdate();
          });
        }
      } else {
        this.$forceUpdate();
      }
    },
    /**
     * When the menu btn is clicked, open the main
     * map form by setting the setLeftSideBarIsOpen
     */
    openMenu() {
      this.$store.commit("setLeftSideBarIsOpen", true);
      if (!this.$lowResolution) {
        document.body.classList.remove("modal-open");
      }
      this.eventBus.$emit("inputPlacehide");
      this.eventBus.$emit("buttonstoggleshow");
      this.eventBus.$emit("settingsviewhide");
      this.eventBus.$emit("settingsButton");
      this.newInfoAvailable = false;
    },

    inputFocused() {
      this.newInfoAvailable = false;
    },

    /**
     * When there is already a place selected
     * and the route action is called, open the
     * side bar and emit and event passing the current
     * place to the map-search component
     * @emits openDirectionsMode
     * @emits switchToDirections
     */
    openDirectionsMode() {
      this.$store.commit("setLeftSideBarIsOpen", true);
      // If the app is in search mode and the search has returned only one
      // place, then it is assumed that the directions button was hit and then
      // the only search result place must auto selected as target
      if (
        this.$store.getters.mode === constants.modes.search &&
        this.mapViewData.places.length === 1
      ) {
        this.place = this.mapViewData.places[0];
        this.eventBus.$emit("openDirectionsMode", this.place);
      } else {
        if (this.place.isEmpty()) {
          // place has no lat and lng
          // Make sure that the place will
          // not be resolved using its name
          // if it is empty when switching to directions
          // It must be resolved using its coordinates
          this.place.placeName = "";
          this.place.unresolved = false;
          this.eventBus.$emit("switchToDirections");
        } else {
          this.eventBus.$emit("openDirectionsMode", this.place);
        }
      }
      this.openingRouteMode = true;
      this.place = new Place();
    },

    /**
     * After each change on the map search we redirect the user to the built target app route
     * The data will be loaded from the path and the map will be updated, keeping the
     * url synchronized with the current map status
     */
    updateAppRoute() {
      if (
        this.$store.getters.mode !== constants.modes.directions &&
        this.place.placeName === ""
      ) {
        this.$store.commit("mode", constants.modes.place);
      }
      const appMode = new AppMode(this.$store.getters.mode);
      const places = this.place.isEmpty() ? [] : [this.place];
      const route = appMode.getRoute(places);
      this.$router.push(route);
    },

    /**
     * Update map places to be displayed
     * @param {*} places
     */
    showSearchResults(places) {
      this.mapViewData = this.mapViewData || new MapViewData();
      this.mapViewData.places = places;
      this.mapViewData.routes = [];
      this.mapViewData.timestamp = Date.now();
      this.eventBus.$emit("mapViewDataChanged", this.mapViewData);
    },

    /**
     * Set a a suggested place as the selected one for a given place input
     * @param {*} data - can be the place object or an object containing the place
     */
    selectPlace(data) {
      // if (data.place) {
      //   this.place = data.place
      // } else {
      //   this.place = data
      // }
      data.index = 1;
      // console.log(this.place)
      // this.eventBus.$emit('GoogleAPI',data.place,1)
      // this.eventBus.$emit('findsetlocation',data,'searchplace','search')
      // this.$store.commit('mode', constants.modes.place)
      // const appMode = new AppMode(this.$store.getters.mode)

      // Define new app route
      // const route = appMode.getRoute([this.place])
      // this.$store.commit('cleanMap', this.$store.getters.appRouteData.places.length === 0)
      // this.$router.push(route)
    },

    /**
     * Reset the place input
     */
    placeCleared() {
      this.place = new Place();
      this.eventBus.$emit("clearMap");
      this.$forceUpdate();
      this.searching = true;
      this.updateAppRoute();
    },
    // hight count dynamic
    setSwitchHeight() {
      if(this.hostportData) {
        let heightGet = document.getElementsByClassName("dropdown-list-right")[0]
          .offsetHeight;
        document
          .getElementsByClassName("simple-place-search-desktop")[0]
          .setAttribute("style", "top:" + (heightGet + 31) + "px;");
        document
          .getElementsByClassName("simple-place-search-desktop")[1]
          .setAttribute("style", "top:" + (heightGet + 140) + "px;");

      }
      else {
        let heightGet = document.getElementsByClassName("dropdown-list-right")[0]
          .offsetHeight;
        document
          .getElementsByClassName("simple-place-search-desktop")[0]
          .setAttribute("style", "top:" + (heightGet + 31) + "px;");
        document
          .getElementsByClassName("simple-place-search-desktop")[1]
          .setAttribute("style", "top:" + (heightGet + 92) + "px;");
      }
    },
    /**
     * Search a place by name
     *
     */
    search() {
      this.searching = true;
      const context = this;

      // Run the place search
      // this.eventBus.$emit('showLoading', true)
      // PlacesSearch(this.place.placeName).then(places => {
      //   if (places.length === 0) {
      //     // this.showInfo(this.$t('simplePlaceSearch.noPlaceFound'))
      //   } else {
      //     context.showSearchResults(places)
      //   }
      // }).catch(response => {
      //   console.log(response)
      //   context.showError(context.$t('simplePlaceSearch.unknownSearchPlaceError'))
      // }).finally(() => {
      //   context.searching = false
      //   context.eventBus.$emit('showLoading', false)
      // })
    },
    // route swap
    swapRoute() {
      this.eventBus.$emit('removePlaceMarkerSelectPlace')
      this.swapButtonToggle = false
      if (
        (this.secondText !== null &&
        this.secondText.length !== 0) ||
        (this.firstText !== null &&
        this.firstText.length !== 0)
      ) {
        let fristtext = this.firstText;
        this.firstText = this.secondText;
        this.secondText = fristtext;
        if (
          (this.routeSwapFieldOne !== null &&
          this.routeSwapFieldOne !== undefined) ||
          (this.routeSwapFieldSecond !== null &&
          this.routeSwapFieldSecond !== undefined)
        ) {
          let routeObjOne = this.routeSwapFieldOne;
          this.routeSwapFieldOne = this.routeSwapFieldSecond;
          this.routeSwapFieldSecond = routeObjOne;

          if(this.routeSwapFieldOne !== null && this.routeSwapFieldOne !== undefined) {
            this.eventBus.$emit("GoogleAPI", this.routeSwapFieldOne, 0);
            this.eventBus.$emit("RoutePlaceOne", this.routeSwapFieldOne);
            this.eventBus.$emit("girastationone", {
              lat: this.routeSwapFieldOne.lat,
              lng: this.routeSwapFieldOne.lng
            });
          }
          if(this.routeSwapFieldSecond !== null && this.routeSwapFieldSecond !== undefined) {
            this.eventBus.$emit("GoogleAPI", this.routeSwapFieldSecond, 1);
            this.eventBus.$emit("RoutePlaceSecond", this.routeSwapFieldSecond);
            this.eventBus.$emit("girastationsecond", {
              lat: this.routeSwapFieldSecond.lat,
              lng: this.routeSwapFieldSecond.lng
            });
          }

          setTimeout(() => {
            if (
              this.routeSwapFieldOne !== null &&
              this.routeSwapFieldOne !== undefined &&
              this.routeSwapFieldSecond !== null &&
              this.routeSwapFieldSecond !== undefined
            ) {
              this.eventBus.$emit("toggleRoundTripmobile");
            }
          }, 500);
        }
      }
    },
    // Insert Hostport Link Clickable
    addHosportInsertLink () {
      this.tooptipShow();
      this.inserthostportlink = false
      this.eventBus.$emit('cursorAddHostPort',true)
    },
    // remove Insert Hostport Link Clickable
    removeHosportInsertLink () {
      this.inserthostportlink = true
      this.show = false;
      this.eventBus.$emit('cursorAddHostPort',false)
    },
    tooptipShow() {
      this.show = true
      setTimeout(() => {
        this.show = false
      }, 8000);
    },
    predictionListMarkup() {
      const predictionsWrapperDiv = document.getElementsByClassName('pac-container')[0];
      return predictionsWrapperDiv;
    },
    initGooglePlacesAutocomplete5() {
      const autocompleteFormField = document.getElementById("autocomplete5");
      const autocomplete = new google.maps.places.AutocompleteService();
      var predictionList = document.getElementsByClassName('pac-container')[0];
      // console.log(predictionList.style.display = 'block')
      // Create a new session token.
      
      var sessionToken = new google.maps.places.AutocompleteSessionToken();
      autocompleteFormField.addEventListener('input', () => {
      if (autocompleteFormField.value) {
        this.placeSuggestionsone = []
        document.getElementsByClassName('pac-container')[0].style.display = 'block'
        autocomplete.getPlacePredictions({
          input: autocompleteFormField.value,
          sessionToken: sessionToken,
          componentRestrictions: {
            country: ["uk", "pt","cz"],
          },
          },
          (predictions, status) => {
            console.log(predictions)
            document.getElementsByClassName('pac-container')[0].innerHTML = '';
            this.displayPredictionSuggestions(predictions, status, predictionList, autocompleteFormField);
          }
        );
      } else {
        document.getElementsByClassName('pac-container')[0].style.display = 'block'
        document.getElementsByClassName('pac-container')[0].innerHTML = '';
        let suggestions = [];
        let get_coockie = localStorage.getItem("history_search");
          if (get_coockie !== "") {
            var convert_arrays = JSON.parse(get_coockie);
            if (convert_arrays.length !== 0) {
              convert_arrays &&
                convert_arrays.map(data => {
                  suggestions.push(data);
                });
            }
          }
          this.placeSuggestionsone = suggestions
        }
      });
    },
    displayPredictionSuggestions(predictions, status, predictionList, autocompleteFormField) {
      // If the service is down, do not return results.
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        document.getElementsByClassName('pac-container')[0].style.display = 'none'
        return;
      }
      for (const prediction of predictions) {
        this.predictionBuilder(prediction, predictionList, autocompleteFormField);
      }
      this.autocompleteKeyboardListener(predictions, predictionList, autocompleteFormField);
    },
    predictionBuilder(prediction, predictionList, autocompleteFormField) {
      // strict prediction filtering based on the street address verification.
      if(prediction.description.includes("Lisbon") || prediction.description.includes("Prague")) {
        const predictionListItem = document.createElement('div');
        predictionListItem.classList.add('pac-item');
        const span = document.createElement('span');
        span.classList.add('pac-icon');
        predictionListItem.appendChild(span);
        predictionListItem.appendChild(document.createTextNode(prediction.description));
        predictionListItem.addEventListener('click', () => {
          this.autocompleteServiceListener(prediction, predictionList, autocompleteFormField);
        });
        document.getElementsByClassName('pac-container')[0].appendChild(predictionListItem);
      }
    },
    autocompleteServiceListener(prediction, predictionList, autocompleteFormField) {
      const service = new google.maps.places.PlacesService(autocompleteFormField);
      service.getDetails({
        placeId: prediction.place_id,
      }, (place, status) => {
        document.getElementsByClassName('pac-container')[0].innerHTML = '';
        document.getElementsByClassName('pac-container')[0].style.display = 'none'
        let country;
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          if (addressType == "country") {
            country = place.address_components[i].long_name;
          }
        }
        let places = new Place(
          place.geometry.location.lng(),
          place.geometry.location.lat(),
          place.name,
          { properties: { layer: "venue", country: country } }
        );

        this.routeSwapFieldSecond = places;
        this.eventBus.$emit("GoogleAPI", places, 1);
        this.eventBus.$emit("RoutePlaceSecond", places);
        this.eventBus.$emit("girastationsecond", {
          lat: places.lat,
          lng: places.lng
        });
        this.firstText = places.placeName;
        this.secondField = true;
        this.showSecondTextFeild=true;
        if(this.routeCheck) {
          this.routedrowdirection = true
        }
        this.$gtag.event("to_location", {
          event_category: "location",
          event_label: "User Selected To Location",
          value: places.placeName
        });
        setTimeout(() => {
          this.setSwitchHeight();
        }, 30);
        // this.selected()
        this.$forceUpdate();
        });
    },
    autocompleteKeyboardListener(predictions, predictionList, autocompleteFormField) {
      const autocompletePredictionMarkup = document.querySelector(`.pac-container`);
      console.log(autocompletePredictionMarkup);
      this.keyCodeListener = (event) => {
        console.log(event.keyCode)
        switch (event.keyCode) {
          case 38:
          // UP
            this.upKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField);
            break;
    
          case 40:
            // DOWN
            this.downKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField);
            break;
    
          case 9:
            // TAB
            this.keyboardAutocomplete(predictions, predictionList, autocompleteFormField, this.keyCodeListener);
            break;
    
          case 13:
            // ENTER
            this.keyboardAutocomplete(predictions, predictionList, autocompleteFormField, this.keyCodeListener);
            break;
          }
        };
      autocompleteFormField.addEventListener(`keydown`, this.keyCodeListener);
    },
    upKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField) {
      if (!(document.querySelector(`.pac-selected`))) {
        // Returns the bottom of the list.
        return this.autocompleteListDecorator(autocompletePredictionMarkup.lastChild, autocompleteFormField);
      } else {
        // Transverse the list in reverse order.
        const previousSibling = document.querySelector(`.pac-selected`).previousSibling;
        if (previousSibling) {
          this.autocompleteListDecorator(previousSibling, autocompleteFormField);
        } else {
          // Return to the last list element at the top of the list.
          this.autocompleteListDecorator(autocompletePredictionMarkup.lastChild, autocompleteFormField);
        }
      }
    },
    downKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField) {
      if (!(document.querySelector(`.pac-selected`))) {
        // Start at the top of the list.
        return this.autocompleteListDecorator(autocompletePredictionMarkup.firstChild, autocompleteFormField);
      } else {
        // Transverse the list from top down.
        const nextSibling = document.querySelector(`.pac-selected`).nextSibling;
        console.log(nextSibling)
        if (nextSibling) {
          this.autocompleteListDecorator(nextSibling, autocompleteFormField);
        } else {
          // Return to the first list element at the end of the list.
          this.autocompleteListDecorator(autocompletePredictionMarkup.firstChild, autocompleteFormField);
        }
      }
    },
    autocompleteListDecorator(autocompletePredictionMarkup, autocompleteFormField) {
      if (document.querySelector('.pac-selected')) {
        document.querySelector('.pac-selected').classList.remove('pac-selected');
      }
      autocompleteFormField.value = autocompletePredictionMarkup.innerHTML;
      autocompletePredictionMarkup.classList.add('pac-selected');
    },
    keyboardAutocomplete(predictions, predictionList, autocompleteFormField, keyCodeListener) {
      if (document.querySelector(`.pac-selected`).innerHTML) {
        for (const prediction of predictions) {
          if (document.querySelector(`.pac-selected`).innerHTML === prediction.description) {
            this.autocompleteServiceListener(prediction, predictionList, autocompleteFormField);
          }
        }
        document.querySelector(`.pac-selected`).classList.remove(`pac-selected`);
        autocompleteFormField.removeEventListener(`keydown`, keyCodeListener);
      }
    },
    initGooglePlacesAutocomplete6() {
      const autocompleteFormField = document.getElementById("autocomplete6");
      const autocomplete = new google.maps.places.AutocompleteService();
      var predictionList = document.getElementsByClassName('pac-container')[0];
      // Create a new session token.
      var sessionToken = new google.maps.places.AutocompleteSessionToken();
      autocompleteFormField.addEventListener('input', () => {
      if (autocompleteFormField.value) {
        this.placeSuggestionsone = []
        document.getElementsByClassName('pac-container')[0].style.display = 'block'
        autocomplete.getPlacePredictions({
          input: autocompleteFormField.value,
          sessionToken: sessionToken,
          componentRestrictions: {
            country: ["uk", "pt","cz"],
          },
          },
          (predictions, status) => {
            document.getElementsByClassName('pac-container')[0].innerHTML = '';
            this.displayPredictionSuggestions6(predictions, status, predictionList, autocompleteFormField);
          }
        );
      } else {
        document.getElementsByClassName('pac-container')[0].style.display = 'none'
        document.getElementsByClassName('pac-container')[0].innerHTML = '';
        let suggestions = [];
        let get_coockie = localStorage.getItem("history_search");
          if (get_coockie !== "") {
            var convert_arrays = JSON.parse(get_coockie);
            if (convert_arrays.length !== 0) {
              convert_arrays &&
                convert_arrays.map(data => {
                  suggestions.push(data);
                });
            }
          }
          this.placeSuggestionsone = suggestions
        }
      });
    },
    displayPredictionSuggestions6(predictions, status, predictionList, autocompleteFormField) {
      // If the service is down, do not return results.
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        document.getElementsByClassName('pac-container')[0].style.display = 'none'
        return;
      }
      for (const prediction of predictions) {
        this.predictionBuilder6(prediction, predictionList, autocompleteFormField);
      }
      this.autocompleteKeyboardListener(predictions, predictionList, autocompleteFormField);
    },
    predictionBuilder6(prediction, predictionList, autocompleteFormField) {
      // strict prediction filtering based on the street address verification.
      if(prediction.description.includes("Lisbon") || prediction.description.includes("Prague")) {
        const predictionListItem = document.createElement('div');
        predictionListItem.classList.add('pac-item');
        const span = document.createElement('span');
        span.classList.add('pac-icon');
        predictionListItem.appendChild(span);
        predictionListItem.appendChild(document.createTextNode(prediction.description));
        predictionListItem.addEventListener('click', () => {
          this.autocompleteServiceListener6(prediction, predictionList, autocompleteFormField);
        });
        document.getElementsByClassName('pac-container')[0].appendChild(predictionListItem);
      }
    },
    autocompleteServiceListener6(prediction, predictionList, autocompleteFormField) {
      const service = new google.maps.places.PlacesService(autocompleteFormField);
      service.getDetails({
        placeId: prediction.place_id,
      }, (place, status) => {
        document.getElementsByClassName('pac-container')[0].innerHTML = '';
        document.getElementsByClassName('pac-container')[0].style.display = 'none'
        let country;
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          if (addressType == "country") {
            country = place.address_components[i].long_name;
          }
        }
        let places = new Place(
          place.geometry.location.lng(),
          place.geometry.location.lat(),
          place.name,
          { properties: { layer: "venue", country: country } }
        );
        this.routeSwapFieldOne = places;
        this.eventBus.$emit("removemarkersecond");
        this.eventBus.$emit("GoogleAPI", places, 0);
        this.eventBus.$emit("RoutePlaceOne", places);
        this.eventBus.$emit("girastationone", {
          lat: places.lat,
          lng: places.lng
        });
        this.secondText = places.placeName;
        this.submitbutton = true;
        this.routedrowdirection = true
        this.$gtag.event("from_location", {
          event_category: "location",
          event_label: "User Selected From Location",
          value: places.placeName
        });
        setTimeout(() => {
          this.setSwitchHeight();
        }, 30);
        // this.selected()
        this.$forceUpdate();
      });
    },
  },
  mounted() {
    let context = this
    document.addEventListener('keydown', function(event){
      if(event.key === "Escape"){
        context.removeHosportInsertLink();
      }
    });
    setTimeout(() => {
      this.setSwitchHeight();
    }, 700);
    let hostportset;
    hostportset = setInterval(() => {
      let hosport = document.getElementsByClassName("custom-div-icon").length;
      if (hosport > 0) {
        for (let index = 0; index < hosport; index++) {
          document.getElementsByClassName("custom-div-icon")[
            index
          ].firstChild.className = "custom-html-icon-div hosport-marker";
        }
        clearInterval(hostportset);
      }
    }, 50);
    let giraset;
    giraset = setInterval(() => {
      let gira = document.getElementsByClassName("custom-gira-icon").length;
      if (gira > 0) {
        for (let index = 0; index < gira; index++) {
          document.getElementsByClassName("custom-gira-icon")[
            index
          ].firstChild.className = "custom-html-icon-div gira-marker";
        }
        clearInterval(giraset);
      }
    }, 50);
    // const autocomplete5 = new google.maps.places.Autocomplete(
    //   document.getElementById("autocomplete5")
    // );

    // Call for AutoComplete5 (Where To ? )
    this.initGooglePlacesAutocomplete5();

    // Call for AutoComplete6 (From )
    this.initGooglePlacesAutocomplete6();

    const defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(38.736946, -9.142685)); 
   
    // const autocomplete6 = new google.maps.places.Autocomplete(
    //   document.getElementById("autocomplete6")
    // );
    // autocomplete6.setComponentRestrictions({
    //   country: ["uk", "pt","cz"]
    // });

  }
};
